import { useFlags } from "launchdarkly-react-client-sdk";

import { NavSection } from "src/components/layout/nav/nav-section";
import { Icon } from "src/components/layout/nav/icons/messages";
import type { ActiveSectionProps } from "src/components/layout/nav/utils";
import { useUser } from "src/contexts/user-context";
import { useEntitlements } from "src/hooks/use-entitlement";
import { useResourcePermission } from "src/components/permission/use-resource-permission";

import type { UseSectionHook } from "./types";

const MESSAGES_HREF = "/native-delivery/messages";

const SETTINGS_ONLY = [
  {
    isSub: true,
    href: "/native-delivery/settings",
    label: "Settings",
  },
];

const ALL_LINKS = [
  {
    isSub: true,
    href: "/native-delivery/campaigns",
    label: "Campaigns",
  },
  {
    isSub: true,
    href: "/native-delivery/messages",
    label: "Messages",
  },
  {
    isSub: true,
    href: "/native-delivery/reporting",
    label: "Reporting",
  },
  {
    isSub: true,
    href: "/native-delivery/templates",
    label: "Templates",
  },
  ...SETTINGS_ONLY,
];

export const useCEPSection: UseSectionHook = () => {
  const { data: entitlementsData } = useEntitlements(false);
  const { cepConfigured } = useUser();
  const { cepLabels } = useFlags();
  const { isPermitted: canViewNativeDelivery } = useResourcePermission({
    v2: { resource: "workspace", grant: "can_view_native_delivery" },
  });

  // The unified campaigns list absorbs journey-triggered messages once labels
  // are on, so the standalone Messages tab is hidden (the message-detail editor
  // stays reachable from campaigns and journeys).
  const links = (cepConfigured ? ALL_LINKS : SETTINGS_ONLY).filter(
    (link) => !(cepLabels && link.href === MESSAGES_HREF),
  );

  return {
    title: "Native Delivery",
    isEnabled:
      Boolean(entitlementsData?.entitlements.cep) && canViewNativeDelivery,
    links,
  };
};

export const CEP = (props: ActiveSectionProps) => {
  const section = useCEPSection();
  return <NavSection icon={Icon} {...section} {...props} />;
};
